import React from 'react';
import { SurveyConfig } from '../../LessonDisplay';
import Survey from 'survey-ui';
import { ActionItem } from '../../../../types';

type SurveyTemplateProps = {
  config: SurveyConfig;
  actionItem: ActionItem;
  urlPrefix?: string;
  completionCallback?: () => void;
};

function SurveyTemplate({
  actionItem,
  config,
  urlPrefix,
  completionCallback,
}: SurveyTemplateProps) {
  const { tokenProvider, customErrorMessage, customLoadingMessage } = config;

  const {
    survey_id: surveyId,
    course_id: courseId,
    lesson_id: lessonId,
    id,
  } = actionItem;

  if (!surveyId) {
    return null;
  }

  const googleAnalyticsSurveyTrackingName = `Survey Action Item: ${courseId} - ${lessonId} - ${id}`;
  const prefix = urlPrefix || '';
  const completionUrl = `${prefix}/${courseId}/${lessonId}/${id}/complete`;

  return (
    <Survey
      surveyId={surveyId}
      googleAnalyticsSurveyTrackingName={googleAnalyticsSurveyTrackingName}
      tokenProvider={tokenProvider}
      customErrorMessage={customErrorMessage}
      customLoadingMessage={customLoadingMessage}
      completionUrl={completionUrl}
      completionCallBack={completionCallback}
    />
  );
}

export default SurveyTemplate;
